import * as React from 'react';

import * as main from '../../../styles/mainOld.module.scss';
import * as courseStructure from './courseStructure.module.scss';

export const CourseStructure = ({ descrText, badgeText }) => {
  return (
    <section className={courseStructure.courseStructure} id="courseStructure">
      <div className="container">
        <h2 className={main.mainTitle}>Структура курса и&nbsp;навыки </h2>
        <p className={courseStructure.courseStructure__description}>{descrText}</p>
        <div className="row">
          <div className={`col-12 col-md-6 col-lg-4 ${courseStructure.courseStructure__col}`}>
            <div className={courseStructure.courseStructure__wrapper}>
              <h3 className={courseStructure.courseStructure__subtitle}>{badgeText} 1</h3>
              <p className={courseStructure.courseStructure__text}>
                Развитие внимания, памяти, воображения и&nbsp;интеллектуальной выносливости
              </p>
            </div>
          </div>
          <div className={`col-12 col-md-6 col-lg-4 ${courseStructure.courseStructure__col}`}>
            <div className={courseStructure.courseStructure__wrapper}>
              <h3 className={courseStructure.courseStructure__subtitle}>{badgeText} 2</h3>
              <p className={courseStructure.courseStructure__text}>
                Технологии ускоренного обучения и&nbsp;работы с&nbsp;большими объемами информации
              </p>
            </div>
          </div>
          <div className={`col-12 col-md-6 col-lg-4 ${courseStructure.courseStructure__col}`}>
            <div className={courseStructure.courseStructure__wrapper}>
              <h3 className={courseStructure.courseStructure__subtitle}>{badgeText} 3</h3>
              <p className={courseStructure.courseStructure__text}>Эффективное чтение</p>
            </div>
          </div>
          <div className={`col-12 col-md-6 col-lg-4 ${courseStructure.courseStructure__col}`}>
            <div className={courseStructure.courseStructure__wrapper}>
              <h3 className={courseStructure.courseStructure__subtitle}>{badgeText} 4</h3>
              <p className={courseStructure.courseStructure__text}>
                Базовая информации по&nbsp;основным школьным дисциплинам
              </p>
            </div>
          </div>
          <div className={`col-12 col-md-6 col-lg-4 ${courseStructure.courseStructure__col}`}>
            <div className={courseStructure.courseStructure__wrapper}>
              <h3 className={courseStructure.courseStructure__subtitle}>{badgeText} 5</h3>
              <p className={courseStructure.courseStructure__text}>Личная эффективность</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
